/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_PushInputs */

const cs_enum_push = /** @type {(inputs: Enum_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push`)
};

const en_enum_push = /** @type {(inputs: Enum_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push`)
};

/**
* | output |
* | --- |
* | "Push" |
*
* @param {Enum_PushInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_push = /** @type {((inputs?: Enum_PushInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_PushInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_push(inputs)
	return cs_enum_push(inputs)
});